class PageFooter extends HTMLElement {
  static get observedAttributes() {
    return ["modified"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  isDev() {
    return new Set(["localhost", "www.path.uiowa.edu", "dev.path.uiowa.edu"]).has(window.location.hostname);
  }

  formatModifiedDate() {
    const raw = this.getAttribute("modified");
    if (!raw) return "Unknown";

    const parsed = new Date(raw.replace(" ", "T"));
    return isNaN(parsed) ? "Unknown" : parsed.toLocaleString();
  }

  getEditButtonHtml() {
    if (!this.isDev()) return "";

    const match = window.location.pathname.match(/test(\d+)\.html$/);
    if (!match) return "";

    return `
      <p>
        <a
          href="/path_handbook/edits/administrator/php/edit_handbook.php?Procode=${match[1]}"
          class="button"
          target="_blank"
          rel="noopener"
        >
          <i class="fa-solid fa-pencil"></i> Submit Edits
        </a>
      </p>
    `;
  }

  getDraftNoticeHtml() {
    if (!this.isDev()) return "";

    return `
\       <div class="draft-notice">DRAFT</div>
    `;
  }

  getHealthCareNotice() {
    if (window.getHandbookLocation() == 4) {
      return '<p>If you have questions or need additional information, please contact <a href="https://uidl.medicine.uiowa.edu/about-us/contact-and-availability" target="_blank">UIDL Client Services</a>.</p>';
    } else {
      return `<p><strong>Note:</strong> The information contained in this handbook is for use by employees of University of Iowa Health Care. For questions and feedback, please email <a href="mailto:pathwebmaster@healthcare.uiowa.edu">pathwebmaster@healthcare.uiowa.edu</a>.</p>`;
    }
  }

  getFormattedModifiedDate() {
    if (!this.getAttribute("modified")) {
      return "";
    }
    return `<p>Updated: ${this.formatModifiedDate()}</p>`;
  }

  render() {
    this.innerHTML = `
      ${this.getDraftNoticeHtml()}
      <div class="page-footer-text">
        ${this.getFormattedModifiedDate()}
        ${this.getEditButtonHtml()}
        ${this.getHealthCareNotice()}
      <p>Vacutainer<sup>&#174;</sup> and/or Microtainer<sup>&#174;</sup> are registered trademarks of Becton, Dickinson &amp; Company.</p>
      </div>
      <az-nav class="az-nav-small"></az-nav>
    `;
  }
}

customElements.define("page-footer", PageFooter);
